import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Card, Col, Image, Row } from 'react-bootstrap';
import './LoginPlanList.scss'
import { useHistory } from 'react-router';
import { useState } from 'react';
import { handlePostPayer } from '../../functions/LoginPage/LoginPageFuncs';
import ModalLogin1 from '../Modals/LoginPageModals/ModalLogin1';
import ErrorToast from '../Toasts/ErrorToast';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
//@ts-ignore
function GridComponent({ payername, planname, contract_number, card_img }) {
    let history = useHistory();
    // console.log('result', planname);
    const storedTheme = sessionStorage.getItem("theme");

    const [spinner, setSpinner] = useState(true);
    const [btndisable, setBtndisable] = useState(true);
    const [showToast, setShowToast] = useState(false)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const showSpinnerTrue = () => setSpinner(true)

    const handleCardClick = () => {
        handleShow();
        handlePostPayer(payername, setSpinner, setBtndisable, setShowToast, setShow);
        sessionStorage.setItem('logo', card_img)
    }
    return (
        <Grid item xs={12} sm={6} md={4} className='card_item'>
            <Card className={storedTheme != 'dark' ? 'LoginPlanList_card' : 'LoginPlanList_card LoginPlanList_card_dark'} onClick={handleCardClick}>
                <Row>
                    <Col>
                        <Image src={`${card_img}`} alt='client_logo' className={storedTheme != 'dark' ? 'login_plan2_card_img' : 'login_plan2_card_img login_plan2_card_img_dark'} loading='lazy'/>
                    </Col>
                    <Col xs={7} className='LoginPlanList_card_content'>
                        {payername}<br />
                        <b className='card_plan2_name'>{planname}</b><br />
                        {contract_number}

                    </Col>
                </Row>
            </Card>
            <ModalLogin1
                show={show}
                handleClose={handleClose}
                oauth_link={''}
                clientName={payername}
                spinner={spinner}
                btndisable={btndisable}
                showSpinnerTrue={showSpinnerTrue} />
            {showToast &&
                <ErrorToast show={showToast} setShowToast={setShowToast} />
            }
        </Grid>
    )
}
//@ts-ignore

function LoginPlanList({ filteredItems, client_name }) {
    console.log('result', filteredItems);
    const path = window.location.pathname
    const path2 = path.split('/')[2]
    console.log("path", path2);
    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={1} style={{ 'display': 'flex', 'flexWrap': 'wrap' }}>
                {filteredItems.map((val: any, i: any) => (
                    (client_name === val.name ?
                        val.plans.map((plan: any, i2: any) => (
                            <GridComponent payername={val.name} planname={plan.legal_entity_name} contract_number={plan.contract_number} card_img={plan.logo} key={i2} />

                        )) :
                        val.name === "Hmny-eny" || val.name === "Hmny-wny"? 
                        path2==="hmny" ?
                        val.plans.map((plan: any, i2: any) => (
                            <GridComponent payername={val.name} planname={plan.legal_entity_name} contract_number={plan.contract_number} card_img={plan.logo} key={i2} />

                        ))
                        :null
                        :
                        null
                        )

                ))}

            </Grid>
        </Box>
    );
}
export default LoginPlanList